import { Input } from 'antd';
import styled from 'styled-components';

export const StyledInput = styled(Input)`
  width: 250px;
`;
